import React from 'react'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'
import { AssessmentsQueueProvider } from './context/AssessmentsQueueProvider'
import { AssessmentsQueueMain } from './components/AssessmentsQueueMain'

export const AssessmentsQueue = () => (
  <NuqsAdapter>
    <AssessmentsQueueProvider>
      <AssessmentsQueueMain />
    </AssessmentsQueueProvider>
  </NuqsAdapter>
)
